import { render, staticRenderFns } from "./EmdLanguageSelect.vue?vue&type=template&id=37d549d8"
import script from "./EmdLanguageSelect.vue?vue&type=script&lang=js"
export * from "./EmdLanguageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d549d8')) {
      api.createRecord('37d549d8', component.options)
    } else {
      api.reload('37d549d8', component.options)
    }
    module.hot.accept("./EmdLanguageSelect.vue?vue&type=template&id=37d549d8", function () {
      api.rerender('37d549d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/atoms/EmdLanguageSelect.vue"
export default component.exports